import React from 'react';
import Leave_Cert from './Leave_Cert';
import '../../../CommonCSS/SocietyCSS.css'


const Leave_CertApp = () => {
  return (
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{ borderRadius: '8px' }}>
          <div className="card-header-css" style={{ borderRadius: '8px', textAlign: 'center' }} >
            <h5> Leaving Certificate </h5>
          </div>
        </div>
        <Leave_Cert/>
      </div>
    </div >
  );
};

export default Leave_CertApp;
